export class ForgotPasswordViewModel {
  email: string = '';
}
